import React from "react";
import { SubscriptionPage } from "./components/SubscriptionPage";

export const AdminSubscriptionTableRoute = () => {
  return <SubscriptionPage />;
};
